<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">

                <div class="row" id="opffp"></div>
                <div class="row" id="anof"></div>
                <div class="row" id="dta_ref">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-2 xtl"><span class="nav-back wt"
                                    onclick="window.location.href='#/promotion'"></span></div>
                            <div class="col-8 tfw-5 tf-18">Invite Link</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row mr-0 tf-18">
                            <div class="col-12 mt-4">*The invitee will get 20 reward</div>
                            <div class="col-12 mt-2">My invite link</div>
                            <div class="col-12 mt-2" id="link">https://fiewin.source-code.co.in//#/LR&RG?C={{info.usercode}}</div>
                            <div class="col-12 mt-2 pa-0">
                                <div class="btn-main act mlink" @click=" copylink()" >Copy link and share</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from "axios";
export default {
    name: "PromotionView",
    data() {
        return {
            userdetails: {
                username: null,
                usercode: 0,
                balance: null,
                page: 1,
                level: 1,
                total22: 0
            },
            invite: {

            },
            inviterecord: {

            },
            info: {

            }

        }

    },
    mounted: function prepare() {
        this.getrecord();
    },
    methods: {
        pop(message) {
            document.getElementById("snackbar").innerHTML = message;
            document.getElementById("snackbar").style.display = "";
            setTimeout(function () { document.getElementById("snackbar").style.display = "none"; }, 1000);
        },
        closenotice() {
            document.getElementById("notice").style.display = "none";
        },
        getrecord() {
            this.userdetails.username = localStorage.getItem('username');

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.userdetails.username).then((res) => {
                this.info = res.data.user_Data[0];
                console.log(this.info);

            }).catch((err) => {
                console.log(err);
            })

            
        },
     
        up() {
            this.userdetails.page = this.userdetails.page + 1;
            this.getrecord();
        },
        down() {
            if (this.userdetails.page == 1) {
                this.pop("First Page Now!")
            } else {
                this.userdetails.page = this.userdetails.page - 1;
                this.getrecord();
            }

        },
        copylink() {
          
            var inputc = document.body.appendChild(document.createElement("input"));
            inputc.value = document.getElementById("link").textContent;
            inputc.focus();
            inputc.select();
            document.execCommand('copy');
            inputc.parentNode.removeChild(inputc); 
            alert("Copied Successfully")
        },
        showlist() {
            document.getElementById("list").style.display = "";
        },
        closelist() {
            document.getElementById("list").style.display = "none";
        }
    }
}

</script>
